import { Instance, types } from 'mobx-state-tree';

import { getPolicies } from '@common/api/policies';
import PoliciesItem from '@common/models/Policies/PoliciesItem';
import TableData, { ITableDataQuery } from '@common/models/TableData';

const Policies = types.compose(
	TableData,
	types
		.model({
			data: types.optional(types.array(PoliciesItem), []),
			group_ids: types.maybe(types.optional(types.string, '')),
			service_id: types.maybe(types.number),
		})
		.volatile(() => ({}))
		.actions((self) => ({
			_fetch: (query: ITableDataQuery) =>
				getPolicies({
					...query,
					...(self.group_ids && { group_ids: self.group_ids }),
					...(self.service_id && { service_id: self.service_id }),
				}),
		})),
);

export default Policies;

export interface IPoliciesModel extends Instance<typeof Policies> {}
